import CompanyDetail from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import {
  addFollowCompanies,
  getCompanyDetail,
  removeFollowCompanies
} from "@/api";
import { INIT_REVIEW } from "@/constants/company";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      loading: {
        page: true,
        follow: false
      },
      company: undefined,
      review: []
    };
  },
  computed: {
    partnerUser() {
      return this.$store.state.domains.user.partnerUser;
    },
    isOurCompany() {
      if (!this.company || !this.partnerUser) {
        return false;
      }
      return this.company.id === this.partnerUser.partner.company.id;
    }
  },
  created() {
    this.getCompanySummary();
  },
  methods: {
    async getCompanySummary() {
      const response = await getCompanyDetail({
        company_id: this.$route.params.companyId
      });

      this.company = response.data;
      this.review = this.reviewShaping(response.data.user_reports);
      this.$set(this.loading, "page", false);
    },
    reviewShaping(review) {
      return INIT_REVIEW.map(e => {
        const count = review.find(f => e.category === f.category);
        return {
          category: e.category,
          count: count ? count.count : 0,
          name: e.name
        };
      });
    },
    async handleClickFollow(isFollow) {
      if (!this.company) return;
      try {
        this.$set(this.loading, "follow", true);
        if (isFollow) {
          await addFollowCompanies({ company_ids: [this.company.id] });
          this.company = {
            ...this.company,
            followed: isFollow
          };
        } else {
          await removeFollowCompanies({ company_ids: [this.company.id] });
          this.company = {
            ...this.company,
            followed: isFollow
          };
        }
      } finally {
        this.$set(this.loading, "follow", false);
      }
    }
  },
  render(createElement) {
    return createElement(CompanyDetail, {
      props: {
        loading: this.loading,
        company: this.company,
        review: this.review,
        isOurCompany: this.isOurCompany
      },
      on: {
        clickFollow: this.handleClickFollow
      }
    });
  }
});
